import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../../redux/modules/user/selectors';
import { useDocumentStore } from '../../document-store/DocumentStore';
import {
  AUTO_DETECT,
  getTranslateLanguage,
  resolveDefaultTargetLanguage,
  TranslateLanguage,
  TranslateSourceLanguage,
} from '../languages';

export const useTranslationControls = () => {
  const user = useSelector(userSelector);
  const profileLocale = user.uiSettings.locale;

  const setTranslationState = useDocumentStore(
    state => state.translationActions.setTranslationState
  );
  const { targetLanguage, sourceLanguage } = useDocumentStore(
    state => state.translationState
  );

  const turnOff = useCallback(() => {
    setTranslationState({
      targetLanguage: undefined,
      sourceLanguage: AUTO_DETECT,
      searchValue: '',
    });
  }, [setTranslationState]);

  const toggle = useCallback(() => {
    if (targetLanguage) {
      turnOff();
      return;
    }

    setTranslationState({
      targetLanguage: resolveDefaultTargetLanguage(profileLocale),
      sourceLanguage: AUTO_DETECT,
    });
  }, [targetLanguage, turnOff, setTranslationState, profileLocale]);

  const setSourceLanguage = useCallback(
    (language: TranslateSourceLanguage) => {
      setTranslationState({ sourceLanguage: language });
    },
    [setTranslationState]
  );

  const setTargetLanguage = useCallback(
    (language: TranslateLanguage) => {
      setTranslationState({ targetLanguage: language });
    },
    [setTranslationState]
  );

  return {
    isActive: Boolean(targetLanguage),
    sourceLanguage,
    targetLanguage,
    profileLanguage: getTranslateLanguage(profileLocale),
    toggle,
    turnOff,
    setSourceLanguage,
    setTargetLanguage,
  };
};
